export default __webpack_public_path__ + "static/media/port1.b3565522.webp";